import { render } from "./Coordinatorsummary.vue?vue&type=template&id=baf67b5a"
import script from "./Coordinatorsummary.vue?vue&type=script&lang=js"
export * from "./Coordinatorsummary.vue?vue&type=script&lang=js"

import "./Coordinatorsummary.vue?vue&type=style&index=0&id=baf67b5a&lang=scss"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__